import apiRoutes from "startups/apiRoutes";
import {
  createActionFetcher,
  createActionSubmitter,
} from "shared/redux-store/defaults";

export const fetchOrderUnitsOverview = createActionFetcher(
  "ORDER_UNITS_OVERVIEW",
  [apiRoutes.orderUnitsOverviewPath(), apiRoutes.meProductsPath()],
);

export const removeOrderUnit = createActionSubmitter("ORDER_UNIT_REMOVE", [
  {
    pathFn: apiRoutes.orderUnitDetailsPath,
    verb: "DELETE",
  },
]);
